import { observer } from "mobx-react";
import {
  isAdminRoute,
  isAnonymousRoute,
  isBoardMemberRoute,
  isShareholderRoute,
  isSuperadminRoute,
  isUserRoute,
  MatchedDCRoute,
} from "./routes";
import UserRoutes from "./UserRoutes";
import { AnonymousRoutesView } from "./AnonymousRoutesView";
import { lazy } from "react";
import { TranslationAdminPage } from "@/i18n/TranslationAdminPage";
import { CompanyByIdPage } from "./CompanyByIdPage";
import { isCompanyId } from "./companyByIdDomain";
const BoardMemberViewRoutes = lazy(() => import("./BoardMemberViewRoutes"));
const ShareholderViewRoutes = lazy(() => import("./ShareholderViewRoutes"));
const AdminRoutes = lazy(() => import("./AdminRoutes"));
const AdminApp = lazy(() => import("@/AdminApp/AdminApp"));

export const RoutesView = observer(({ route }: { route?: MatchedDCRoute }) => {
  const render = () => {
    switch (true) {
      case isBoardMemberRoute(route):
        return <BoardMemberViewRoutes />;
      case isShareholderRoute(route):
        return <ShareholderViewRoutes />;
      case isAdminRoute(route) && isCompanyId(route.params.orgNo):
        return <CompanyByIdPage companyId={route.params.orgNo} />;
      case isAdminRoute(route):
        return <AdminRoutes />;
      case isSuperadminRoute(route):
        return <AdminApp />;

      case isUserRoute(route):
        return <UserRoutes />;
      case isAnonymousRoute(route):
        return <AnonymousRoutesView />;
      case route?.name === "translation-admin":
        if (import.meta.hot) {
          return <TranslationAdminPage />;
        } else {
          return null;
        }
      default:
        return null;
    }
  };

  return <>{render()}</>;
});
